export default "/_next/static/6853028fd37d107aec5a5a5c28a7c1cf.png";